import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { ContextProvider } from './Context/ContextProvider';
import { RouterProvider } from 'react-router-dom';
import router from './router';
import { LanguageProvider } from './Context/LanguageContext ';
import { SearchProvider } from './Context/SearchContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <ContextProvider>
        <SearchProvider>
          <RouterProvider router={router} />
        </SearchProvider>
      </ContextProvider>
    </LanguageProvider>
  </React.StrictMode>
);
reportWebVitals();
